import { jsx as _jsx } from "react/jsx-runtime";
import { Settings } from '@otp/icons';
import clsx from 'clsx';
import { Menu } from '../../menu';
import styles from './index.module.css';
export const ActionsColumn = (props) => {
    const { icons: iconsProp = [], actions = [], classes, className } = props;
    const icons = [...iconsProp];
    if (actions === null || actions === void 0 ? void 0 : actions.length) {
        icons.push({
            icon: (_jsx(Menu, { items: actions, noSpacing: true, classes: { root: classes === null || classes === void 0 ? void 0 : classes.menu }, children: _jsx(Settings, { className: styles.actionsColumnIcon }) })),
            onClick: () => { },
        });
    }
    return (_jsx("div", { className: clsx(styles.actionsColumnWrapper, className), "data-testid": "actions-column-wrapper", onClick: (e) => e.stopPropagation(), children: icons === null || icons === void 0 ? void 0 : icons.map((icon, id) => (_jsx("div", { className: styles.actionsColumn, children: _jsx(icon.icon.type, Object.assign({ onClick: icon.onClick }, icon.icon.props)) }, id))) }));
};
